import { Star } from 'lucide-react';

export default function RatingStars({ rating }) {
  return <span aria-hidden="true" className="relative inline-flex shrink-0 text-ee-gold">
    <span className="inline-flex">{[0, 1, 2, 3, 4].map(i => <Star key={i} className="h-4 w-4" strokeWidth={1.5} />)}</span>
    <span className="absolute inset-y-0 left-0 overflow-hidden" style={{ width: `${Math.max(0, Math.min(5, rating)) * 20}%` }}>
      <span className="flex w-max">{[0, 1, 2, 3, 4].map(i => <Star key={i} className="h-4 w-4 fill-current" strokeWidth={1.5} />)}</span>
    </span>
  </span>;
}